// src/router/pagamentos-antecipados.js

const pagamentosAntecipadosBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Pagamentos Antecipados',
        to: 'PagamentosAntecipados'
    }
]

export default [
    {
        path: '/pagamentos-antecipados',
        name: 'PagamentosAntecipados',
        component: () => import('@/views/PagamentosAntecipados/PagamentoAntecipadoListPage.vue'),
        meta: {
            title: 'Pagamentos Antecipados',
            breadcrumb: pagamentosAntecipadosBreadCrumb
        },
    },
    {
        path: '/pagamentos-antecipados/novo',
        name: 'PagamentoAntecipadoNovo',
        component: () => import('@/views/PagamentosAntecipados/NovoPagamentoAntecipadoPage.vue'),
        meta: {
            title: 'Novo Pagamento Antecipado',
            breadcrumb: [
                ...pagamentosAntecipadosBreadCrumb,
                {
                    label: 'Novo Pagamento Antecipado',
                    to: 'PagamentoAntecipadoNovo'
                }
            ]
        }
    },
    {
        path: '/pagamentos-antecipados/:id/edit',
        name: 'PagamentoAntecipadoEdit',
        component: () => import('@/views/PagamentosAntecipados/EditPagamentoAntecipadoPage.vue'),
        meta: {
            title: 'Detalhes do Pagamento Antecipado',
            breadcrumb: [
                ...pagamentosAntecipadosBreadCrumb,
                {
                    label: 'Edição Pagamento Antecipado',
                    to: 'PagamentoAntecipadoEdit'
                }
            ]
        }
    }

];
